module.exports = __webpack_public_path__ + "img/55_moby_machupichu.56614da1.jpg";